export const COLOR = '#007066';
export const LIGHT_COLOR = '#E0F2F1';
export const BASE_URL = 'https://xgenious.com';
export const CANONICAL = `${BASE_URL}/products/botmerze-ai-chatbot-saas-ecommerce`;
export const DEMO_URL = 'https://botmerze.bytesed.com';
export const CODECANYON_URL = 'https://codecanyon.net/item/botmerze-ai-chatbot-saas-for-ecommerce-with-woocommerce-shopify-api-integration/63267734';
export const REGULAR_PRICE = 49;
export const BUNDLE_PRICE = 69;
export const EXTENDED_PRICE = 199;
export const BUNDLE_PRODUCT_PATH = 'botmerze-everyting-bundle';
export const EXCLUSIVE_PRODUCT_PATH = 'botmerze-exclusive-pack';

export const REVIEWS: { name: string; rating: number; category: string; body: string }[] = [
  {
    name: 'tanburogluguney',
    rating: 5,
    category: 'Code Quality',
    body: "I am extremely satisfied with this script. The developer has truly thought everything through. The structure is logical, professional, and very well organized — all essential features are already built in. This is not a rushed or basic script; it's strategically designed for building a serious and scalable platform. Compared to other scripts I evaluated, this one feels far more complete, stable, and carefully developed. No regrets.",
  },
  {
    name: 'Stambol',
    rating: 5,
    category: 'Code Quality',
    body: 'This script exceeded expectations in terms of functionality, code quality, and overall usability. The documentation was clear, and integration into our existing environment was smooth and hassle-free. Support from the author was responsive and helpful, demonstrating strong commitment to customer satisfaction. Highly recommended for anyone looking for a reliable and well-built solution.',
  },
  {
    name: 'theunionsoft',
    rating: 5,
    category: 'Customer Support',
    body: 'I had some difficulties with the installation process, but the team went above and beyond to help me. They handled everything professionally, set up the VPS, and ensured the script was fully working. Their patience, cooperation, and commitment to customer satisfaction really impressed me. I highly recommend their products and services.',
  },
  {
    name: 'Nouvintou',
    rating: 5,
    category: 'Customer Support',
    body: "Team support and the product are great. I've been a customer for a couple of years and have seen the version enhancements and updates, which shows serious work backing up the solution and great customer service.",
  },
  {
    name: 'MyKodezone',
    rating: 5,
    category: 'Code Quality',
    body: 'The code quality and support are excellent. We launched our business website and app with their help — our customers now place orders online and our team delivers services on time without phone calls. Truly a super service. I highly recommend them to anyone looking for reliable software and support.',
  },
];
